module.exports = __webpack_public_path__ + "img/c3ab85b.png";